<script>
import Request from '@src/mixins/request'
import { property as endpoint } from '@src/data/endpoint.json'

export default {
  mixins: [Request],

  data() {
    return {
      properties: [],
    }
  },

  computed: {
    drawer: {
      get() {
        return this.$store.state.app.drawer
      },
      set(val) {
        this.$store.commit('app/SET_DRAWER', val)
      },
    },
  },

  methods: {
    onSwitchPropertyClicked() {
      this._fetchData({
        url: endpoint.list,
        data: { selects: ['id', 'name', 'url'] },
      }).then((data) => {
        this.properties = data
      })
    },
  },
}
</script>

<template>
  <VToolbar app clipped-left dark>
    <VToolbarSideIcon @click="drawer = !drawer" />
    <span class="title ml-3 mr-5 hidden-xs-only">
      {{ $store.state.app.currentProperty.name }}
    </span>
    <VSpacer />
    <VToolbarItems>
      <VMenu transition="slide-y-transition" bottom left offset-y>
        <VBtn slot="activator" icon @click="onSwitchPropertyClicked">
          <VIcon>swap_horiz</VIcon>
        </VBtn>
        <VList>
          <VProgressCircular v-if="loading" color="gold" indeterminate />
          <VListTile
            v-for="property in properties"
            v-else
            :key="property.id"
            :to="{ name: 'dashboard', params: { url: property.url } }"
          >
            <VListTileTitle class="gold--text">
              {{ property.name }}
            </VListTileTitle>
          </VListTile>
        </VList>
      </VMenu>
    </VToolbarItems>
    <VToolbarItems>
      <VBtn icon>
        <VIcon>notifications</VIcon>
      </VBtn>
    </VToolbarItems>
    <VToolbarItems>
      <VMenu transition="slide-y-transition" bottom left offset-y>
        <VBtn slot="activator" icon>
          <VIcon>account_circle</VIcon>
        </VBtn>
        <VList>
          <VListTile href="#">
            <VListTileAction>
              <VIcon>lock</VIcon>
            </VListTileAction>
            <VListTileContent>
              <VListTileTitle>Change password</VListTileTitle>
            </VListTileContent>
          </VListTile>
          <VListTile :to="{ name: 'logout' }">
            <VListTileAction>
              <VIcon>power_settings_new</VIcon>
            </VListTileAction>
            <VListTileContent>
              <VListTileTitle>Log out</VListTileTitle>
            </VListTileContent>
          </VListTile>
        </VList>
      </VMenu>
    </VToolbarItems>
  </VToolbar>
</template>
